export default "__VITE_ASSET__BUE7ESwG__"